import { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { PermissionsError } from 'services/errors';
import {
  type AccessPathKey,
  subroutes,
  type ManageConnectionsAccess,
} from '../subroutes';

export const useAccessibleRoutes = (access: ManageConnectionsAccess) => {
  const history = useHistory();

  const accessibleSubroutes = useMemo(() => {
    return Object.entries(subroutes).reduce<typeof subroutes>(
      (acc, [key, route]) => {
        const hasAccess = Object.entries(route.accessPaths).some(
          ([accessKey, accessLevel]) =>
            access[accessKey as AccessPathKey]?.[accessLevel]
        );
        if (hasAccess) {
          acc[key] = route;
        }
        return acc;
      },
      {}
    );
  }, [access]);

  useEffect(() => {
    if (
      subroutes[history.location.pathname] &&
      !accessibleSubroutes[history.location.pathname]
    ) {
      const firstAccessibleRoute = Object.values(accessibleSubroutes)[0];
      if (firstAccessibleRoute) {
        history.replace(firstAccessibleRoute.path);
      } else {
        throw new PermissionsError();
      }
    }
  }, [accessibleSubroutes, history, history.location.pathname]);

  if (!access.enabled) {
    throw new PermissionsError();
  }

  return accessibleSubroutes;
};
